// @ts-nocheck

import { createSelector } from 'reselect';

const emptyObj = {};
const emptyArr = [];

export const selectAnimationsState = createSelector(
  (state) => state.animations,
  (animationsState) => animationsState ?? emptyObj,
);

export const selectOddsTravelAnimations = createSelector(
  selectAnimationsState,
  (animations) => animations.oddsTravel ?? emptyArr,
);
